import {Button, Classes, Dialog} from '@blueprintjs/core';
import {ReactElement} from 'react';
import {useBlocker} from 'react-router';

interface Props {
	dirty: boolean,
}

export default function ConfirmNavigationDialog({dirty}: Props): ReactElement | null {
	const blocker = useBlocker(dirty);

	if (blocker.state !== 'blocked')
		return null;

	return (
		<Dialog isOpen={true} title="Confirm Navigation" onClose={blocker.reset}>
			<div className={Classes.DIALOG_BODY}>
				You have unsaved data on this page. Are you sure you want to navigate away?
			</div>

			<div className={Classes.DIALOG_FOOTER}>
				<div className={Classes.DIALOG_FOOTER_ACTIONS}>
					<Button intent="primary" text="Stay On Page" onClick={blocker.reset} />
					<Button intent="danger" text="Discard Changes" onClick={blocker.proceed} />
				</div>
			</div>
		</Dialog>
	);
}
